module.exports = __webpack_public_path__ + "img/Nauru.e5ac714f.png";